import moment from "moment";

export const defaultFilter = {
  institute: 0,
  branch: 0,
  board: 0,
  classRoom: 0,
  startingDate: '0',
  endingDate: '0',
}

export const dateFilterFunc = (classified?: string, currentMonth?: any) => {
  switch (classified) {
    case 'today': {
      return ({ startingDate: moment().format("YYYY-MM-DD"), endingDate: moment().add(1, 'days').format("YYYY-MM-DD") })
    }
    case 'yesterday': {
      return ({ startingDate: moment().subtract(1, 'days').format("YYYY-MM-DD"), endingDate: moment().format("YYYY-MM-DD") })
    }
    case 'week': {
      return ({ startingDate: moment().subtract(7, 'days').format("YYYY-MM-DD"), endingDate: moment().add(1, 'days').format("YYYY-MM-DD") })
    }
    case 'month': {
      return ({ startingDate: currentMonth?.startOf('month').format('YYYY-MM-DD'), endingDate: currentMonth?.add(1, 'months').startOf('month').format('YYYY-MM-DD') })
    }
    default: {
      return ({ startingDate: 0, endingDate: 0 })
    }
  }
}

export const defaultFilterLeaderboard={
  instituteId:0,
  branchId:0,
  boardId:0,
  sectionId:0,
  sectionSubjectId:0,
  branchClassRoomId:0,
  page:1,
  pageSize:10
}

export const defaultFilterReports={
  instituteId:0,
  branchId:0,
  boardId:0,
  sectionId:0,
  sectionSubjectId:0,
  branchClassRoomId:0
}

export const defaultSalesReports={
  branchClassRoomId:0,
  startingDate: '0',
  endingDate: '0',
  paymentStatus:'0'
}
